import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
} from "@angular/core";
import { Subscription } from "rxjs";

import { IdentificacaoModel } from "src/app/models/IdentificacaoModel";
import { ConfiguracoesUsuario } from "src/app/models/usuario/ConfiguracoesUsuario";
import { UsuarioPreferenciasService } from "src/app/services/data-services/usuario.preferencias.service";
import { ErrorHandlerService } from "src/app/services/errorHandler.service";

@Component({
  selector: "app-form-identificacao",
  templateUrl: "./form-identificacao.component.html",
  styleUrls: ["./form-identificacao.component.scss"],
})
export class FormIdentificacaoComponent implements OnInit, OnDestroy {
  @Output() onsaving = new EventEmitter();
  @Output() onsaved = new EventEmitter<string>();
  @Output() confirmarAlteracoes = new EventEmitter<boolean>(false);
  @ViewChild("fileInput") fileInputRef: ElementRef;

  public defaultPhoto = "assets\\ui\\user.svg";
  public model: IdentificacaoModel;
  public email: string;
  private sUserdata: Subscription;

  constructor(
    private usuarioPreferenciasService: UsuarioPreferenciasService,
    private errorHandlerService: ErrorHandlerService
  ) {}

  public ngOnInit(): void {
    this.sUserdata = this.usuarioPreferenciasService
      .getConfiguracoes()
      .subscribe((config) => {
        this.model = new IdentificacaoModel(config);
        this.email = config.email;
      });
  }

  public ngOnDestroy(): void {
    this.sUserdata.unsubscribe();
  }

  public abrir(): void {
    this.cancelar();
  }

  public fechar(): void {}

  public cancelar() {
    this.model = new IdentificacaoModel(
      this.usuarioPreferenciasService.getConfiguracoesvalue
    );
  }

  public salvar(): void {
    try {
      this.onsaving.emit();

      const prefs = <ConfiguracoesUsuario>(
        this.usuarioPreferenciasService.getConfiguracoesvalue
      );

      prefs.nome = this.model.nome;
      prefs.sobrenome = this.model.sobrenome;
      prefs.foto = this.model.foto;

      this.usuarioPreferenciasService.alterarConfiguracoes(prefs);
      this.onsaved.emit("Dados atualizados com sucesso!");
    } catch (error) {
      this.errorHandlerService.handleError(error);
    }
  }

  public pickPhoto(): void {
    const el = <HTMLInputElement>this.fileInputRef.nativeElement;
    el.click();
  }

  public onFileChanged(evt: Event): void {
    const el = <HTMLInputElement>evt.target;
    const file = el.files[0];

    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
      const originalB64 = reader.result.toString();

      const maxWidth = 48;
      const maxHeight = 48;

      const img = document.createElement("img");

      // When the event "onload" is triggered we can resize the image.
      img.onload = () => {
        // We create a canvas and get its context.
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const imgWidth = img.width;
        const imgHeight = img.height;

        const ratio = imgWidth / imgHeight;

        let finalImageWidth = maxWidth;
        let finalImageHeight = maxHeight;

        if (ratio > 1) {
          finalImageHeight = maxHeight;
          finalImageWidth = finalImageHeight * ratio;
        } else if (ratio < 1) {
          finalImageWidth = maxWidth;
          finalImageHeight = finalImageWidth / ratio;
        }

        // We set the dimensions at the wanted size.
        canvas.width = maxWidth;
        canvas.height = maxHeight;

        // We resize the image with the canvas method drawImage();
        ctx.drawImage(
          img,
          canvas.width / 2 - finalImageWidth / 2,
          canvas.height / 2 - finalImageHeight / 2,
          finalImageWidth,
          finalImageHeight
        );

        this.model.foto = canvas.toDataURL();
      };
      img.src = originalB64;
    };

    reader.onerror = (error) => {
      this.errorHandlerService.handleError(error);
    };
  }
}
